/** Seconds to retain list-page query results in RTK cache after the last subscriber unmounts. */
export const LIST_QUERY_CACHE_TTL_SECONDS = 300;

export const CHAT_TAG = 'Chat';
export const CHAT_DOCUMENTS_TAG = 'ChatDocuments';
export const CHAT_HISTORY_LIST_TAG = 'ChatHistoryList';
export const CHAT_SHARING_TAG = 'ChatSharing';
export const CHAT_SHARE_CANDIDATES_TAG = 'ChatShareCandidates';
export const DRAFT_SEARCH_TEXT_TAG = 'DraftSearchText';

export const CASES_LIST_TAG = 'CasesList';
export const MATTER_ABOUT_TAG = 'MatterAbout';

export const ACTIVE_USERS_LIST_TAG = 'ActiveUsersList';
export const USER_ABOUT_TAG = 'UserAbout';

export const USERS_TAGS = [ACTIVE_USERS_LIST_TAG, USER_ABOUT_TAG] as const;

export const CHAT_TAGS = [
  CHAT_TAG,
  CHAT_DOCUMENTS_TAG,
  CHAT_HISTORY_LIST_TAG,
  CHAT_SHARING_TAG,
  CHAT_SHARE_CANDIDATES_TAG,
  DRAFT_SEARCH_TEXT_TAG,
] as const;

export const CASES_TAGS = [CASES_LIST_TAG, MATTER_ABOUT_TAG] as const;

export const PROJECTS_LIST_TAG = 'ProjectsList';
export const PROJECT_TAG = 'Project';
export const PROJECT_FILES_TAG = 'ProjectFiles';
export const PROJECTS_TAGS = [PROJECTS_LIST_TAG, PROJECT_TAG, PROJECT_FILES_TAG] as const;

export const AERIALS_LIST_TAG = 'AerialsList';
export const AERIALS_TAGS = [AERIALS_LIST_TAG] as const;

export const DEPARTMENTS_LIST_TAG = 'DepartmentsList';
export const TEAMS_LIST_TAG = 'TeamsList';
export const ORG_STRUCTURE_TAGS = [DEPARTMENTS_LIST_TAG, TEAMS_LIST_TAG] as const;

export const TOOLKIT_TAG = 'Toolkit';
export const TOOLKIT_TAGS = [TOOLKIT_TAG] as const;
